module.exports = __webpack_public_path__ + "static/media/foodprint_app3.fab40653.jpg";